import cn from 'clsx';
import { useDeviceType } from '@cian/ui-kit';

import styles from './styles.css';

export interface IPageWrapperProps {
  children?: React.ReactNode;
}

export const PageWrapper: React.FC<IPageWrapperProps> = ({ children }) => {
  const deviceType = useDeviceType();

  return (
    <div className={cn(styles['layout'], styles[deviceType])}>
      <div className={cn(styles['content'], styles[deviceType])}>{children}</div>
    </div>
  );
};

PageWrapper.displayName = 'PageWrapper';
